import renderImage from '../../../../source/importImg'
import InputNumber from '../../../ReusableComponents/SliderBox/InputNumber'
import servoPopupStyle from './ServoDetailsPopup.module.css'

function TimeEditPopup(props) {
    const {
        timeEditPopUp,
        setTimeEditPopUp,
        createActionState,
        handleActionDataChange,
        getServoMinMax,
    } = props

    if (!timeEditPopUp.isShow) {
        return null
    }

    const { min, max } = getServoMinMax('T')
    const value =
        createActionState?.allActions?.[timeEditPopUp.actionNumber]?.data?.['T']
            ?.value || 0

    const handleClose = () => {
        setTimeEditPopUp({
            isShow: false,
            actionNumber: 0,
        })
    }

    return (
        <div className={servoPopupStyle.servoPopupMain}>
            <div className={servoPopupStyle.servoPopupBox}>
                <img
                    className={servoPopupStyle.closeBtn}
                    src={renderImage('clos')}
                    alt="close"
                    onClick={handleClose}
                />
                <div className={servoPopupStyle.servoPopupBody}>
                    <p className={servoPopupStyle.bodyPtag}>
                        Edit Time (Millisecond)
                    </p>
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'center',
                            marginTop: '1rem',
                        }}
                    >
                        <InputNumber
                            value={value}
                            min={min}
                            max={max}
                            onChange={(newValue) =>
                                handleActionDataChange(
                                    timeEditPopUp.actionNumber,
                                    'T',
                                    newValue
                                )
                            }
                            style={{
                                width: '140px',
                                height: '45px',
                                fontSize: '20px',
                            }}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default TimeEditPopup
